module.exports = __webpack_public_path__ + "static/media/ic_questionnaire_pre_medical_success.9751aea9.svg";